class EventsHubTabs {
  constructor(root) {
    this.root = root;
    if (!this.root) return;

    this.tabs = [...this.root.querySelectorAll('[data-events-hub-tab]')];
    this.panels = [...this.root.querySelectorAll('[data-events-hub-panel]')];
    if (!this.tabs.length || !this.panels.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab.dataset.eventsHubTab));
    });
  }

  activate(view) {
    this.tabs.forEach((tab) => {
      const active = tab.dataset.eventsHubTab === view;
      tab.setAttribute('aria-selected', String(active));
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.eventsHubPanel !== view;
    });

    document.dispatchEvent(
      new CustomEvent('events-view:show', {
        detail: { view },
      }),
    );
  }
}

function initEventsHubTabs() {
  document.querySelectorAll('[data-events-hub]').forEach((root) => new EventsHubTabs(root));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initEventsHubTabs);
} else {
  initEventsHubTabs();
}
